import * as React from 'react';
import { throttle } from '@cian/newbuilding-utils';
import { Tabs } from '@cian/ui-kit/prev';
import { useSelector } from 'react-redux';
import { getElementOffsetTop } from './getElementOffsetTop';
import { modalFullscreen } from '../../constants/gallery';
import { getGalleryMedia } from '../../selectors/gallery/galleryMedia';

export const TabsContainer = () => {
  const gallery = useSelector(getGalleryMedia);
  const [activeTab, setActiveTab] = React.useState(gallery[0].id);

  function scroll() {
    gallery.map(item => {
      const offsetTop = getElementOffsetTop(`#${item.id}`);

      if (offsetTop <= 200) {
        setActiveTab(item.id);
      }
    });
  }

  const handleScroll = throttle(400, scroll);

  React.useLayoutEffect(() => {
    const modalElement = document.querySelector(`#${modalFullscreen}`);
    /* istanbul ignore else */
    if (modalElement) {
      modalElement.addEventListener('scroll', handleScroll);
    }

    /* istanbul ignore next */
    return () => {
      if (modalElement) {
        modalElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const onClick = (id: string) => {
    const modalElement = document.querySelector(`#${modalFullscreen}`);
    const activeSection = document.querySelector<HTMLDivElement>(`#${id}`);
    if (modalElement && activeSection) {
      const offsetTop = activeSection.offsetTop;
      const agent = window.navigator.userAgent;
      const isIE = /MSIE|Trident|Edge/.test(agent);

      if (isIE) {
        modalElement.scrollTo(0, offsetTop);
      } else {
        modalElement.scrollTo({
          behavior: 'smooth',
          left: 0,
          top: offsetTop,
        });
      }
    }
  };

  return (
    <Tabs
      activeTab={activeTab}
      onChange={onClick}
      tabs={gallery.map(item => ({
        value: item.id,
        title: item.title,
      }))}
    />
  );
};
